function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  width: 20,
  height: 20,
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1 12.675L15.6 11.1667V7.45003C15.6413 4.59615 13.5712 2.1491 10.75 1.71669C9.14813 1.50574 7.533 1.99483 6.31727 3.05899C5.10153 4.12316 4.40295 5.65933 4.4 7.27503V11.1667L2.9 12.675C2.5148 13.0666 2.40151 13.6508 2.61239 14.1581C2.82328 14.6653 3.31736 14.9969 3.86666 15H6.66666V15.2834C6.74771 17.0448 8.23834 18.4087 10 18.3334C11.7616 18.4087 13.2523 17.0448 13.3333 15.2834V15H16.1333C16.6826 14.9969 17.1767 14.6653 17.3876 14.1581C17.5985 13.6508 17.4852 13.0666 17.1 12.675ZM11.6667 15.2834C11.5707 16.1161 10.8362 16.7257 10 16.6667C9.16382 16.7257 8.42934 16.1161 8.33333 15.2834V15H11.6667V15.2834ZM5.575 12.35L4.59166 13.3334H15.4083L14.4167 12.35C14.1047 12.0355 13.9308 11.6097 13.9333 11.1667V7.41669C13.976 5.39844 12.5259 3.6569 10.5333 3.33336C9.40174 3.18568 8.26235 3.54211 7.41666 4.30836C6.55973 5.05617 6.06758 6.13768 6.06666 7.27503V11.1667C6.06701 11.6109 5.89003 12.0369 5.575 12.35Z",
  fill: "black"
}));

function SvgIconNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.f74bfd19.svg";
export { ForwardRef as ReactComponent };